import { atom } from 'recoil';

import { AvailableDeliveryDueDate } from '../../../../generated/graphql';
import { DynamicSchemaValue } from '../../../types/DynamicSchema';
import {
  EditingProjectAssetFilesState,
  EditingProjectBriefFilesState,
  EditingProjectState,
  EditingProjectStateErrors,
} from '../../../types/EditingProjectState';
import { InputtedCreationSet } from '../../../types/InputtedCreationSet';
import { InputtingCreativeFormat } from '../../../types/InputtingCreativeFormat';
import { InputtingCreativeFormatsFilter } from '../../../types/InputtingCreativeFormatsFilter';

export const editingProjectStateDefault: EditingProjectState = {
  title: 'Untitled Project',
  matchingFormat: 'auto',
  creationSet: null,
  inputtingCreativeFormats: [],
  inputtingCreativeFormatsFilter: {
    networksAndPlacements: [],
    creativeTypes: [],
  },
  creativeBriefValue: null,
  assetCategoryValue: null,
};

export const editingProjectStateAtom = atom<EditingProjectState>({
  key: 'editingProjectStateAtom',
  default: editingProjectStateDefault,
});

export const editingProjectCreationSetsAtom = atom<ReadonlyArray<InputtedCreationSet>>({
  key: 'editingProjectCreationSetsAtom',
  default: [],
});

export const editingProjectInputtingCreativeFormatsAtom = atom<ReadonlyArray<InputtingCreativeFormat>>({
  key: 'editingProjectInputtingCreativeFormatsAtom',
  default: [],
});

export const editingProjectInputtingCreativeFormatsFilterAtom = atom<Readonly<InputtingCreativeFormatsFilter>>({
  key: 'editingProjectInputtingCreativeFormatsFilterAtom',
  default: {
    networksAndPlacements: [],
    creativeTypes: [],
  },
});

export const editingProjectTitleAtom = atom<Readonly<string>>({
  key: 'editingProjectTitleAtom',
  default: 'Untitled Project',
});

export const editingProjectCreativeBriefValueAtom = atom<Readonly<DynamicSchemaValue> | null>({
  key: 'editingProjectCreativeBriefValueAtom',
  default: null,
});

export const editingProjectAssetCategoryValueAtom = atom<Readonly<DynamicSchemaValue> | null | undefined>({
  key: 'editingProjectAssetCategoryValueAtom',
  default: null,
});

export const editingProjectStateErrorsAtom = atom<EditingProjectStateErrors>({
  key: 'editingProjectStateErrorsAtom',
  default: {
    assetCategoryValueEmptyErrors: {},
    creativeBriefValueUnacceptableErrors: {},
    creativeBriefValueEmptyErrors: {},
    creationSetsErrors: [],
    titleErrors: [],
  },
});

export const editingProjectBriefFilesStateAtom = atom<EditingProjectBriefFilesState>({
  key: 'editingProjectBriefFilesStateAtom',
  default: {
    briefFiles: {},
    uploadingBriefFiles: {},
    uploadingFilesProgress: {},
  },
});

export const editingProjectAssetFilesStateAtom = atom<EditingProjectAssetFilesState>({
  key: 'editingProjectAssetFilesStateAtom',
  default: {
    assetFiles: [],
    uploadingAssetFiles: {},
    uploadingAssetFilesProgress: {},
  },
});

export const editingProjectDeliveryDueDatesAtom = atom<ReadonlyArray<AvailableDeliveryDueDate>>({
  key: 'editingProjectDeliveryDueDatesAtom',
  default: [],
});
